module.exports = __webpack_public_path__ + "static/media/phone-mock.0399045b.png";